<template>
  <div class="header_container">
    <div class="hideicon" @click="hideNav()">
      <i class="el-icon-s-fold"></i>
    </div>
    <div class="top-right">
      <div class="news" @click="showDialog()">
        <i class="el-icon-bell"></i>
        <div class="dian" v-show="showTips"></div>
      </div>
      <div class="userbox" @mouseenter="enter()" @mouseleave="leave()">
        <img
          src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80"
        />
        <span>{{name}}</span>
        <div class="user-operate" ref="operate">
          <ul>
            <li @click="modifyPassword()">修改密码</li>
            <li @click="exit()">退出</li>
          </ul>
        </div>
      </div>
      <!-- <div class="exit" @click="exit()">退出</div> -->
    </div>
    <el-dialog title="公告" :visible.sync="dialogVisible">
      <div class="title">{{info.name}}</div>
      <div class="content">{{info.content}}</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      avatar:
        "http://img5.imgtn.bdimg.com/it/u=1109507497,1637582812&fm=26&gp=0.jpg",
      dialogVisible: false,
      showTips: false
    };
  },
  props: {
    name: [String],
    info: [Object]
  },
  // computed:{
  //   showDian(){
  //     if(this.info.id == localStorage.getItem('systeminfo')){
  //       return {this.}
  //     }else{
  //       return true
  //     }
  //   }
  // },
  watch: {
    info(newval,oldval) {
      console.log(newval)
      console.log(localStorage.getItem("systeminfo"))
      if (newval.id == localStorage.getItem("systeminfo")) {
        this.showTips = false;
      } else {
        this.showTips = true;
      }
    }
  },
  methods: {
    enter() {
      this.$refs.operate.style.display = "block";
      this.$refs.operate.style.transform = "translateY(0px)";
    },
    leave() {
      this.$refs.operate.style.display = "none";
      this.$refs.operate.style.transform = "translateY(-100px)";
    },
    exit() {
      this.$emit("exit");
    },
    hideNav() {
      this.$emit("hideNav");
    },
    modifyPassword() {
      this.$emit("modifyPassword");
    },
    showDialog() {
      this.dialogVisible = true;
      localStorage.setItem('systeminfo',this.info.id);
      this.showTips = false;
    }
  }
};
</script>

<style scoped>
.header_container {
  background-color: #eff2f7;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px 0 20px;
}
.hideicon i {
  font-size: 20px;
}
.top-right {
  display: flex;
  align-items: center;
  height: 60px;
}
.top-right .news {
  position: relative;
  margin-right: 20px;
  cursor: pointer;
}
.top-right .news i {
  font-size: 26px;
  color: #f17d2e;
}
.top-right .news .dian {
  position: absolute;
  top: 0;
  right: -4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f92f23;
}
.top-right .userbox {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 15px;
  height: 60px;
}
.top-right .userbox img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 10px;
  margin-left: 8px;
}
.top-right .userbox .user-operate {
  position: absolute;
  width: 120px;
  top: 53px;
  border-radius: 2px;
  background: #fff;
  color: #606266;
  display: none;
  transform: translateY(-100px);
  transition: 0.3s;
}
.top-right .userbox .user-operate li {
  text-align: center;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #909399;
  cursor: pointer;
}
.top-right .userbox .user-operate li:hover {
  color: #333;
}

.exit {
  font-size: 16px;
  cursor: pointer;
}
/* .avator {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 37px;
} */
.el-dropdown-menu__item {
  text-align: center;
}
.title {
  font-size: 16px;
  text-align: center;
  padding: 0 15px 15px;
}
.content {
  text-align: center;
  font-size: 14px;
  padding: 10 15px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/headTop.vue